import { PREVIEW_CONTRACT_TYPE } from '@/stores/home/home.interface';

namespace Agreement {
  export enum API {
    'get_loan_agreement_info' = '/fast-escrow/usercenter/apply/get_contract_url',
    'get_preview_contract' = '/fast-escrow/usercenter/account/gen_preview_contract',
    'get_contracts_list' = '/fast-escrow/usercenter/account/get_contracts',
    'presigned_url' = '/user/sec/fast-escrow/transaction/gen_presigned_url_from_uc',
  }
}

export interface IPreviewContractParams {
  //   UNKNOWN = 0;
  // EN =1;
  // THAILAND = 2;
  // VIETNAMESE=3;//越南语言
  language: 0 | 1 | 2 | 3;
  contract_type: PREVIEW_CONTRACT_TYPE;
}

export default Agreement;

export enum IAddendumType {
  agreement,
  limit,
}

export interface IContractInfo {
  contract_id: string;
  contract_url: string;
  // uc
  contract_url_presigned?: string;
  // account
  contract_presigned_url?: string;
  accept_time: number;
  contract_picture_url?: string;
  contract_picture_url_presigned?: string;
  type?: IAddendumType;
}

export interface IAddendumInfo {
  contract_id: string;
  contract_url_en: string;
  contract_url_local: string;
  contract_picture_url_en: string;
  contract_picture_url_local: string;
  accept_time: number;
}
